import { combineReducers } from 'redux';

import {
    COLLECTION_FAILURE,
    COLLECTION_REQUEST,
    COLLECTION_SUCCESS
} from '../actions/types/dashboard-action-types';
import {
    SAVE_CANVAS_SETTINGS,
    UPDATE_CANVAS_DATA_PARAM
} from '../actions/types/canvas-action-types';
import { OPEN_RIGHT_PANE, CLOSE_RIGHT_PANE } from '../../common/actions/types/right-pane-action-types';

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case COLLECTION_REQUEST:
            newState = {};
            break;
        case COLLECTION_SUCCESS:
            newState = action.payload.entities.canvases;
            break;
        case SAVE_CANVAS_SETTINGS:
            newState = {
                ...state,
                [action.canvasId]: {
                    ...state[action.canvasId],
                    params: {
                        ...state[action.canvasId].params,
                        ...action.updatedParams
                    }

                }
            };
            break;
        default:
            newState = state;
    }

    return newState;
}

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case COLLECTION_REQUEST:
            newState = true;
            break;
        case COLLECTION_SUCCESS:
        case COLLECTION_FAILURE:
            newState = false;
            break;
        default:
            newState = state;
    }

    return newState;
}

function formState( state = {}, action ){
    let newState;
    switch( action.type ){
        case OPEN_RIGHT_PANE:
            if( action.activeRightPane === 'canvasSettings' ){
                newState = { ...state, ...action.attributes.params };
            }
            else{
                newState = {};
            }
            break;
        case UPDATE_CANVAS_DATA_PARAM:
            newState = { ...state, ...action.updatedParam };
            break;
        case CLOSE_RIGHT_PANE:
        case SAVE_CANVAS_SETTINGS:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    byId,
    formState,
    isLoading
} );
